<template>
  <div class="p-postEditor__itemWrapper">
    <image-uploader-selecter
      :image-uploader-selecter="imageUploaderSelector"
      :image-direct-url.sync="imageDirectUrl"
      @close-image-uploader-selecter="closeImageUploaderSelector"
      @select-picture="updateImage"
      @upload-download-image="uploadDownloadImage"
      @upload-picture="uploadPicture"
    />
  </div>
</template>

<script>
import ImageUploaderSelecter from '@/components/postEditor/parts/ImageUploaderSelecter'

export default {
  components: {
    ImageUploaderSelecter
  },
  props: {
    imageUploaderSelector: {
      type: Boolean,
      required: true
    }
  },
  data: () => {
    return {
      imageDirectUrl: ''
    }
  },
  methods: {
    updateImage (picture) {
      this.$emit('set-html-table-img', this.setImgTag(picture.file.fitMiddle.url))
    },
    uploadDownloadImage (downloadImage) {
      this.$emit('set-html-table-img', this.setImgTag(downloadImage.file.fitMiddle.url))
    },
    uploadPicture (picture) {
      this.$emit('set-html-table-img', this.setImgTag(picture.file.fitMiddle.url))
    },
    closeImageUploaderSelector () {
      if (this.imageDirectUrl !== '') {
        this.$emit('set-html-table-img', this.setImgTag(this.imageDirectUrl))
      }
      this.$emit('close-image-dialog')
    },
    setImgTag (url) {
      return `<p><img src= "${url}" alt="tableImg"></p>`
    }
  }
}
</script>

<style scoped></style>
